import { Component, Vue } from 'vue-property-decorator';

import { NextPrevBlockViewModel } from './NextPrevArticleModule.types';
import NextPrevArticle from '@/components/NextPrevArticle/NextPrevArticle.vue';
import { getComponentProps } from '@/utils/vueUtils';
import ContentType from '@/common/interfaces/enums/ContentType';

const NextPrevArticleModuleProps = Vue.extend({
  props: getComponentProps<NextPrevBlockViewModel>({
    PrevArticle: {
      ArticleLink: { Title: 'Underwater colour', Link: '#' },
      Image: {
        Url: '/images/whale.jpg',
        Alt: 'ice cave',
      },
      Date: '',
      Type: 0,
    },
    NextArticle: {
      ArticleLink: { Title: 'Underwater colour', Link: '#' },
      Image: {
        Url: '/images/whale.jpg',
        Alt: 'ice cave',
      },
      Date: '',
      Type: 0,
    },
  }),
});

@Component({
  components: {
    NextPrevArticle,
  },
})
export default class NextPrevArticleModule extends NextPrevArticleModuleProps {}
